import { UI_RichText } from 'ui/components/1-atoms/RichText/RichText';
import styles from './AccordionItem.module.scss';
import { UI_Icon } from 'ui/components/1-atoms/Media/Icon/Icon';
import Close from 'ui/icons/close.svg';
import Open from 'ui/icons/open.svg';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { UI_Heading } from 'ui/components/1-atoms/Heading/Heading';
import { accordionItemAnchorId } from '../accordionAnchor';

export interface AccordionItemProps {
	id: string;
	openByDefault?: boolean;
	title: string;
	htmlContent: string;
	onClick?: () => void;
}

export const UI_AccordionItem = ({ id, title, htmlContent, openByDefault, onClick }: AccordionItemProps) => {
	const anchorId = accordionItemAnchorId(title, id);
	const panelId = `${anchorId}-panel`;
	const [open, setOpen] = useState(openByDefault);

	useEffect(() => {
		setOpen(openByDefault);
	}, [openByDefault]);

	return (
		<>
			<UI_Heading className={classNames(styles.AccordionItem, styles[`AccordionItem___${open ? 'open' : ''}`])} headingLevel="h3" style="lg">
				<button
					onClick={() => {
						setOpen((prev) => !prev);
						onClick?.();
					}}
					aria-expanded={open}
					className={styles.AccordionItem_trigger}
					aria-controls={panelId}
					aria-label={title}
					id={anchorId}
				>
					<span className={styles.AccordionItem_title}>
						<span className={styles.AccordionItem_iconWrapper} aria-hidden="true">
							{open ? (
								<UI_Icon size="sm" className={classNames(styles.AccordionItem_icon, styles.AccordionItem_icon___close)}>
									<Close />
								</UI_Icon>
							) : (
								<UI_Icon size="sm" className={classNames(styles.AccordionItem_icon, styles.AccordionItem_icon___open)}>
									<Open />
								</UI_Icon>
							)}
						</span>
						<span>{title}</span>
					</span>
				</button>
			</UI_Heading>
			{htmlContent && (
				<div
					id={panelId}
					role="region"
					aria-labelledby={anchorId}
					className={classNames(styles.AccordionItem_panel, styles[`AccordionItem_panel___${open ? 'open' : ''}`])}
					hidden={!open}
				>
					<UI_RichText content={htmlContent} className={styles.AccordionItem_content} />
				</div>
			)}
		</>
	);
};
